export enum MedSummaryAssetTabs {
  ALL_ENTRIES = 'all-entries',
  SOURCE_FILES = 'source-files',
}

export const getMedSummaryAssetTabName = (tab: MedSummaryAssetTabs) => {
  switch (tab) {
    case MedSummaryAssetTabs.ALL_ENTRIES:
      return 'All Entries'
    case MedSummaryAssetTabs.SOURCE_FILES:
      return 'Source Files'
  }
}

export enum MedSummaryAssetRouteSegments {
  ADD_FILES = 'add-files',
}

// Update polling backs off 5s -> 10s -> 15s while a run is active.
export const kMedSummaryAssetPollIntervalsMs = [5000, 10000, 15000]

// Mirrors the backend's SUPPORTED_SOURCE_MIME_TYPES (paxton_app/med_summary/pipeline/source_pdf.py):
// non-PDF sources are converted to PDF by the update pipeline (AI-94).
export const kMedSummaryAssetAcceptedFileTypes = {
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/gif': ['.gif'],
  'image/webp': ['.webp'],
  'image/bmp': ['.bmp'],
  'image/tiff': ['.tif', '.tiff'],
}
